<template>
    <div>
        <v-row class="header ml-0 mr-0">
            <v-row class="pl-5">
                <v-col class="white--text text-body-2 colunaCabecalhoCodigo">
                    <span class="font-weight-bold">Código</span>
                    <p class="mb-0">{{movimentacao.codigo}}</p>
                </v-col>
                <v-col class="white--text text-body-2 colunaCabecalho">
                    <span class="font-weight-bold">Criado por</span>
                    <p class="mb-0">{{movimentacao.usuarioCadastro}}</p>
                </v-col>
                <v-col class="white--text text-body-2 colunaCabecalho">
                    <span class="font-weight-bold">Data de Finalização</span>
                    <p class="mb-0">{{movimentacao.dataDeFinalizacao | azDate()}}</p>
                </v-col>
                <v-col class="white--text text-body-2 colunaCabecalho">
                    <span class="font-weight-bold">Situação</span>
                    <p class="mb-0">{{movimentacao.situacao | azEnum(situacaoMovimentacao)}}</p>
                </v-col>
            </v-row>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: 'MovimentacaoDetalheCabecalhoBaixa',
        props: ['movimentacao'],
    }
</script>

<style scoped lang="stylus">
    .colunaCabecalhoCodigo
        max-width 150px !important
        max-width 150px !important
    .colunaCabecalho
        max-width 190px !important
        max-width 190px !important
    .styleButton
        font-size 10px
</style>
